import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { Switch } from 'react-router-dom';
import PropsRoute from './components/PropsRoute';
import Home from './pages/Home';
import Services from './pages/Services';
import Solutions from './pages/Solutions';
import ContactUs from './pages/ContactUs';
import useLocationBlocker from './hooks/useLocationBlocker';
import Privacy from './pages/Privacy';
import Company from './pages/Company';

function Routing({ setTab }) {
  useLocationBlocker();
  return (
    <Switch>
      <PropsRoute
        exact
        path='/services'
        component={Services}
        setTab={setTab}
      />
      <PropsRoute
        exact
        path='/solutions'
        component={Solutions}
        setTab={setTab}
      />
      <PropsRoute
        exact
        path='/contact'
        component={ContactUs}
        setTab={setTab}
      />
      <PropsRoute
        exact
        path='/company'
        component={Company}
        setTab={setTab}
      />
      <PropsRoute
        exact
        path='/privacy'
        component={Privacy}
        setTab={setTab}
      />
      <PropsRoute
        path='/'
        component={Home}
        setTab={setTab}
      />
    </Switch>
  );
}

Routing.propTypes = {
  setTab: PropTypes.func.isRequired,
  openLoginDialog: PropTypes.func.isRequired,
  openTermsDialog: PropTypes.func.isRequired,
};

export default memo(Routing);
